import React, { useState } from 'react';
import T from 'prop-types';
import { filter } from 'lodash-es';

import Modal from '../../../../components/Modal';
import Button from '../../../../components/Buttons/Button';
import TickersSearch from '../../../../components/TickersSearch';

const ModalTicker = ({ open, outsideTickers = [], onClose, changeOutsideTickers }) => {
  const [tickers, setTickers] = useState(outsideTickers);

  const handleSelectTickers = (selectedTicker) => {
    const selectedTickers = tickers || [];
    const selected = [
      ...selectedTickers,
      { id: null, ticker: selectedTicker.ticker, companyName: selectedTicker.name, active: true },
    ];
    setTickers(selected);
  };

  // eslint-disable-next-line max-len
  const handleRemoveTicker = (removedTicker) =>
    setTickers(filter(tickers, ({ ticker }) => ticker !== removedTicker.ticker));

  const handleSubmit = () => {
    changeOutsideTickers(tickers);
  };

  const tickersPresent = tickers.length;

  return (
    <Modal
      open={open}
      size="xs"
      cardSize="lg"
      closeButtonVersionButton
      shouldCloseOnOverlayClick={false}
      modalContentClass="research-library-modal"
      onClose={() => onClose(false)}
    >
      <div className="ticker-modal">
        <div className="ticker-modal-body">
          <div className="ticker-modal-header">
            <h1>Select Tickers</h1>
            <div className="d-flex justify-content-center">
              <p>
                Receive an email notification when new reports are added that include your selected
                tickers.
              </p>
            </div>
            <TickersSearch
              tickers={tickers}
              assetName="va_companies"
              onSelected={handleSelectTickers}
            />
          </div>
          <div className="tickers-content">
            {tickersPresent ? (
              <div className="ticker-list">
                {tickers.map((ticker) => (
                  <div key={ticker.ticker} className="ticker-item">
                    <p>{`${ticker.companyName || ''} (${ticker.ticker})`}</p>
                    <Button
                      size="sm"
                      shape="square"
                      variant="secondary"
                      onClick={() => handleRemoveTicker(ticker)}
                    >
                      <span className="hicon-round-minus" />
                    </Button>
                  </div>
                ))}
              </div>
            ) : (
              <div className="empty-tickers">
                <p>Search for your tickers above. They will show up here once added.</p>
              </div>
            )}
          </div>
        </div>
        <div className="ticker-modal-footer">
          <div className="buttons">
            <Button size="lg" variant="secondary" onClick={() => onClose(false)}>
              Cancel
            </Button>
            <Button size="lg" onClick={handleSubmit}>
              Save
            </Button>
          </div>
        </div>
        <div />
      </div>
    </Modal>
  );
};

ModalTicker.propTypes = {
  open: T.bool.isRequired,
  outsideTickers: T.array,
  onClose: T.func.isRequired,
  changeOutsideTickers: T.func.isRequired,
};

export default ModalTicker;
